import { render } from "./JoinDone.vue?vue&type=template&id=7b36e8ed"
import script from "./JoinDone.vue?vue&type=script&lang=js"
export * from "./JoinDone.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__